// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// ILendingPoolAddressesProvider https://snowscan.xyz/address/0xb6A86025F0FE1862B372cb0ca18CE3EDe02A318f
export const POOL_ADDRESSES_PROVIDER = '0xb6A86025F0FE1862B372cb0ca18CE3EDe02A318f';

// ILendingPool https://snowscan.xyz/address/0x4F01AeD16D97E3aB5ab2B501154DC9bb0F1A5A2C
export const POOL = '0x4F01AeD16D97E3aB5ab2B501154DC9bb0F1A5A2C';

// https://snowscan.xyz/address/0x102Bf2C03c1901AdBA191457A8c4A4eF18b40029
export const POOL_IMPL = '0x102Bf2C03c1901AdBA191457A8c4A4eF18b40029';

// ILendingPoolConfigurator https://snowscan.xyz/address/0x230B618aD4C475393A7239aE03630042281BD86e
export const POOL_CONFIGURATOR = '0x230B618aD4C475393A7239aE03630042281BD86e';

// https://snowscan.xyz/address/0x3616f776F2b5fAd02F2478DFd4822Fc70d24399E
export const POOL_CONFIGURATOR_IMPL = '0x3616f776F2b5fAd02F2478DFd4822Fc70d24399E';

// IAaveOracle https://snowscan.xyz/address/0xdC336Cd4769f4cC7E9d726DA53e6d3fC710cEB89
export const ORACLE = '0xdC336Cd4769f4cC7E9d726DA53e6d3fC710cEB89';

// ILendingRateOracle https://snowscan.xyz/address/0xc34254642B504484465F38Cb1CC396d45a9c7c80
export const LENDING_RATE_ORACLE = '0xc34254642B504484465F38Cb1CC396d45a9c7c80';

// IAaveProtocolDataProvider https://snowscan.xyz/address/0x65285E9dfab318f57051ab2b139ccCf232945451
export const AAVE_PROTOCOL_DATA_PROVIDER = '0x65285E9dfab318f57051ab2b139ccCf232945451';

// https://snowscan.xyz/address/0xd01607c3C5eCABa394D8be377a08590149325722
export const LENDING_POOL_COLLATERAL_MANAGER = '0xd01607c3C5eCABa394D8be377a08590149325722';

// https://snowscan.xyz/address/0x3C06dce358add17aAf230f2234bCCC4afd50d090
export const POOL_ADMIN = '0x3C06dce358add17aAf230f2234bCCC4afd50d090';

// https://snowscan.xyz/address/0x56C1a4b54921DEA9A344967a8693C7E661D72968
export const EMERGENCY_ADMIN = '0x56C1a4b54921DEA9A344967a8693C7E661D72968';

// ICollector https://snowscan.xyz/address/0x5ba7fd868c40c16f7aDfAe6CF87121E13FC2F7a0
export const COLLECTOR = '0x5ba7fd868c40c16f7aDfAe6CF87121E13FC2F7a0';

// https://snowscan.xyz/address/0x01D83Fe6A10D2f2B7AF17034343746188272cAc9
export const DEFAULT_INCENTIVES_CONTROLLER = '0x01D83Fe6A10D2f2B7AF17034343746188272cAc9';

// https://snowscan.xyz/address/0x5CfCd7E6D055Ba4f7B998914336254aDE3F69f26
export const EMISSION_MANAGER = '0x5CfCd7E6D055Ba4f7B998914336254aDE3F69f26';

// https://snowscan.xyz/address/0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4
export const DEBT_SWAP_ADAPTER = '0x63dfa7c09Dc2Ff4030d6B8Dc2ce6262BF898C8A4';

// https://snowscan.xyz/address/0x7902F3c60f05b5A6b7e4Ce0Cac11Cb17bC8e607c
export const CONFIG_ENGINE = '0x7902F3c60f05b5A6b7e4Ce0Cac11Cb17bC8e607c';

// https://snowscan.xyz/address/0xFdf9714c74df0535D77dACDbf621E0c977Cd5bc5
export const MIGRATION_HELPER = '0xFdf9714c74df0535D77dACDbf621E0c977Cd5bc5';

// https://snowscan.xyz/address/0x4235E22d9C3f28DCDA82b58276cb6370B01265C2
export const POOL_ADDRESSES_PROVIDER_REGISTRY = '0x4235E22d9C3f28DCDA82b58276cb6370B01265C2';

// https://snowscan.xyz/address/0x7fc3FCb14eF04A48Bb0c12f0c39CD74C249c37d8
export const PROOF_OF_RESERVE = '0x7fc3FCb14eF04A48Bb0c12f0c39CD74C249c37d8';

// https://snowscan.xyz/address/0x80f2c02224a2E548FC67c0bF705eBFA825dd5439
export const PROOF_OF_RESERVE_AGGREGATOR = '0x80f2c02224a2E548FC67c0bF705eBFA825dd5439';

// https://snowscan.xyz/address/0x6e66E50870A93691C1b953788A3219e01fDdeDD7
export const RATES_FACTORY = '0x6e66E50870A93691C1b953788A3219e01fDdeDD7';

// https://snowscan.xyz/address/0x935b362EE3E1f342cc48118C528AAbee5118F6e6
export const REPAY_WITH_COLLATERAL_ADAPTER = '0x935b362EE3E1f342cc48118C528AAbee5118F6e6';

// https://snowscan.xyz/address/0x2EcF2a2e74B19Aab2a62312167aFF4B78E93B6C5
export const SWAP_COLLATERAL_ADAPTER = '0x2EcF2a2e74B19Aab2a62312167aFF4B78E93B6C5';

// https://snowscan.xyz/address/0x11979886A6dBAE27D7a72c49fCF3F23240D647bF
export const UI_INCENTIVE_DATA_PROVIDER = '0x11979886A6dBAE27D7a72c49fCF3F23240D647bF';

// https://snowscan.xyz/address/0x00e50FAB64eBB37b87df06Aa46b8B35d5f1A4e1A
export const UI_POOL_DATA_PROVIDER = '0x00e50FAB64eBB37b87df06Aa46b8B35d5f1A4e1A';

// https://snowscan.xyz/address/0x73e4898a1Bfa9f710B6A6AB516403A6299e01fc6
export const WALLET_BALANCE_PROVIDER = '0x73e4898a1Bfa9f710B6A6AB516403A6299e01fc6';

// https://snowscan.xyz/address/0x68c815cB8C8390bc3F2CE99265044dEC9D350C49
export const WETH_GATEWAY = '0x68c815cB8C8390bc3F2CE99265044dEC9D350C49';

// https://snowscan.xyz/address/0xA28820b8af102fAABAAAdaf94224353Dc772DC99
export const CLINIC_STEWARD = '0xA28820b8af102fAABAAAdaf94224353Dc772DC99';

export const CHAIN_ID = 43114;
export const ASSETS = {
  WETHe: {
    decimals: 18,
    id: 0,
    UNDERLYING: '0x49D5c2BdFfac6CE2BFdB6640F4F80f226bc10bAB',
    A_TOKEN: '0x53f7c5869a859F0AeC3D334ee8B4Cf01E3492f21',
    V_TOKEN: '0x4e575CacB37bc1b5afEc68a0462c4165A5268983',
    INTEREST_RATE_STRATEGY: '0x9A2362afe62D7cE7a69f2cE61aED6aB0aF109294',
    ORACLE: '0x976B3D034E162d8bD72D6b9C989d545b839003b0',
  },
  DAIe: {
    decimals: 18,
    id: 1,
    UNDERLYING: '0xd586E7F844cEa2F87f50152665BCbc2C279D8d70',
    A_TOKEN: '0x47AFa96Cdc9fAb46904A55a6ad4bf6660B53c38a',
    V_TOKEN: '0x1852DC24d1a8956a0B356AA18eDe954c7a0Ca5ae',
    INTEREST_RATE_STRATEGY: '0x7abB575574e221eF52A571974EdeBA870Fc0bBd8',
    ORACLE: '0x0b47c51CCD4FaDe1D93C750bFCAB0a5ce8734ED0',
  },
  USDTe: {
    decimals: 6,
    id: 2,
    UNDERLYING: '0xc7198437980c041c805A1EDcbA50c1Ce5db95118',
    A_TOKEN: '0x532E6537FEA298397212F09A61e03311686f548e',
    V_TOKEN: '0xfc1AdA7A288d6fCe0d29CcfAAa57Bc9114bb2DbE',
    INTEREST_RATE_STRATEGY: '0x04932041605c7ab646E0ff209d94241cd4651598',
    ORACLE: '0x5b7810a910B4a878AaA4800a824E5E5796838009',
  },
  USDCe: {
    decimals: 6,
    id: 3,
    UNDERLYING: '0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664',
    A_TOKEN: '0x46A51127C3ce23fb7AB1DE06226147F446e4a857',
    V_TOKEN: '0x848c080d2700CBE1B894a3374AD5E887E5cCb89c',
    INTEREST_RATE_STRATEGY: '0x09F9063Fa492d562f414514c596c7f3c01c14714',
    ORACLE: '0xb0D7A8bbDcdb1203850b742bB4d7f57a1F1C8483',
  },
  AAVEe: {
    decimals: 18,
    id: 4,
    UNDERLYING: '0x63a72806098Bd3D9520cC43356dD78afe5D386D9',
    A_TOKEN: '0xD45B7c061016102f9FA220502908f2c0f1add1D7',
    V_TOKEN: '0x8352E3fd18B8d84D3c8a1b538d788899073c7A8E',
    INTEREST_RATE_STRATEGY: '0x6724e923E4bb58fCdF7CEe7A5E7bBb47b99C2647',
    ORACLE: '0x3CA13391E9fb38a75330fb28f8cc2eB3D9ceceED',
  },
  WBTCe: {
    decimals: 8,
    id: 5,
    UNDERLYING: '0x50b7545627a5162F82A992c33b87aDc75187B218',
    A_TOKEN: '0x686bEF2417b6Dc32C50a3cBfbCC3bb60E1e9a15D',
    V_TOKEN: '0x2dc0E35eC3Ab070B8a175C829e23650Ee604a9eB',
    INTEREST_RATE_STRATEGY: '0xD9Dee878Eb31303FD58D412cE79439400b340A22',
    ORACLE: '0x2779D32d5166BAaa2B2b658333bA7e6Ec0C65743',
  },
  WAVAX: {
    decimals: 18,
    id: 6,
    UNDERLYING: '0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7',
    A_TOKEN: '0xDFE521292EcE2A4f44242efBcD66Bc594CA9714B',
    V_TOKEN: '0x66A0FE52Fb629a6cB4D10B8580AFDffE888F5Fd4',
    INTEREST_RATE_STRATEGY: '0x9A2362afe62D7cE7a69f2cE61aED6aB0aF109294',
    ORACLE: '0x0A77230d17318075983913bC2145DB16C7366156',
  },
} as const;
